"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrResponsiveImg = void 0;
const react_1 = __importDefault(require("react"));
const fdr_regular_basis_fdr_img_1 = require("@hotelplan/fdr.regular.basis.fdr-img");
const fdr_regular_basis_fdr_picture_1 = require("@hotelplan/fdr.regular.basis.fdr-picture");
function FdrResponsiveImg({ image, specs, ImageElement = fdr_regular_basis_fdr_img_1.FdrImg, imageProps = {}, children, }) {
    return (react_1.default.createElement(fdr_regular_basis_fdr_picture_1.FdrPicture, { sources: specs, sizes: image.resized },
        react_1.default.createElement(ImageElement, Object.assign({ image: image, lazy: true }, imageProps), children)));
}
exports.FdrResponsiveImg = FdrResponsiveImg;
//# sourceMappingURL=fdr-responsive-img.js.map